import { useMemo } from 'react';
import type { BaseShow, ShowFilter } from '@/types';
import { getShowParam } from '@/utils';
import { SelectEcho, SelectOption } from '@/components/echo/primitives';

type ShowFilterProps = {
  shows: BaseShow[];
  selectedShow: ShowFilter;
  onApply: (selectedShow: ShowFilter) => void;
  onOpen?: () => void;
  renderAllShows?: boolean;
};

const ShowFilter = ({
  shows = [],
  selectedShow,
  onApply,
  onOpen,
  renderAllShows = true,
}: ShowFilterProps) => {
  const displayLabel = useMemo(() => {
    const param = getShowParam(selectedShow);
    if (param === 'all') return 'Show: All';
    const match = shows.find((s) => s.id === param);
    return match ? `Show: ${match.name}` : 'Select a show';
  }, [selectedShow, shows]);

  return (
    <SelectEcho
      id="show-select"
      displayLabel={displayLabel}
      placeholder="Shows"
      value={getShowParam(selectedShow)}
      onClick={onOpen}
      onChange={(selectedValue) => {
        const selected = String(selectedValue);
        const selectedShow: ShowFilter =
          selected === 'all'
            ? 'all'
            : shows.find((show) => show.id === selected)
              ? selected
              : undefined;

        onApply(selectedShow);
      }}
    >
      {renderAllShows && <SelectOption value="all">All</SelectOption>}
      {shows?.length > 0 &&
        shows.map((show) => (
          <SelectOption key={show.id} value={show.id}>
            {show.name}
          </SelectOption>
        ))}
    </SelectEcho>
  );
};

export default ShowFilter;
